import { createContext } from "react";
const UserContext=createContext("Justin");
export default UserContext;